import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/ThemeProvider";
import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="w-9 h-9 rounded-lg"
      aria-label={theme === "dark" ? "Zum hellen Modus wechseln" : "Zum dunklen Modus wechseln"}
    >
      {theme === "dark" ? (
        <Sun size={18} className="text-muted-foreground hover:text-foreground transition-colors" />
      ) : (
        <Moon size={18} className="text-muted-foreground hover:text-foreground transition-colors" />
      )}
    </Button>
  );
}
